<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<!-- Conteúdo centralizado com largura máxima (card 3683): encostado à esquerda, a tela sobrava
     vazia à direita em monitor largo. -->
<div class="register-deal__page">
  <header class="page-header">
    <h2>Registrar deal</h2>
  </header>

  <!-- O subtítulo NÃO promete que o Cognito descobre o CNPJ sozinho, como no desenho:
       o backend precisa do CNPJ para criar a empresa e a reserva antes de qualquer
       documento. Prometer na tela o que o fluxo não faz é pior que a frase mais curta. -->
  <p class="register-deal__subtitle">
    @if (visaoInterna()) {
      Informe o CNPJ do cliente e suba a documentação. Se a empresa já estiver cadastrada e sem
      parceiro, o deal é ligado a ela. O Cog identifica o que é cada arquivo.
    } @else {
      Informe o CNPJ do cliente e suba a documentação — reservamos a empresa para você por 90 dias,
      e o Cog identifica o que é cada arquivo.
    }
  </p>

  <div class="register-deal__layout">
    <!-- 1. CNPJ ------------------------------------------------------------------ -->
    <section class="register-deal__card">
      @if (createdDeal(); as deal) {
        <div class="register-deal__done">
          <i class="pi pi-check-circle register-deal__done-icon"></i>
          <div>
            <h3>Deal #{{ deal.sequentialId }} registrado</h3>
            <p class="register-deal__done-lead">
              @if (deal.reservationExpiresAt) {
                <strong>{{ deal.corporateName }}</strong> está reservado para você.
              } @else {
                <!-- Deal da Legatus não reserva CNPJ: a reserva existe para um parceiro não
                     roubar o cliente de outro (card 3169). -->
                Deal aberto para <strong>{{ deal.corporateName }}</strong
                >, sem reserva de CNPJ
              }
            </p>
          </div>
        </div>

        <dl class="register-deal__summary">
          <div>
            <dt>CNPJ</dt>
            <dd>{{ deal.cnpj | vaultMaskCnpj }}</dd>
          </div>
          <div>
            <dt>Valor</dt>
            <dd>{{ deal.amount | currency: deal.currencyCode : 'symbol' : '1.2-2' : 'pt-BR' }}</dd>
          </div>
          <!-- Prazo e flat fee estimado (card 3683). -->
          <div>
            <dt>Prazo da captação</dt>
            <dd>{{ termYearsLabel(deal.termYears) }}</dd>
          </div>
          @if (
            deal.flatFeePercent &&
            deal.estimatedFlatFeeAmount !== null &&
            deal.estimatedFlatFeeAmount !== undefined
          ) {
            <div>
              <dt>Flat fee estimado</dt>
              <dd>
                {{ deal.flatFeePercent | vaultFormatPercent: 2 }} ≈
                {{
                  deal.estimatedFlatFeeAmount
                    | currency: deal.currencyCode : 'symbol' : '1.2-2' : 'pt-BR'
                }}
              </dd>
            </div>
          }
          <div>
            <dt>Etapa</dt>
            <dd>{{ deal.stage }}</dd>
          </div>
          @if (deal.reservationExpiresAt) {
            <div>
              <dt>Exclusividade até</dt>
              <dd>{{ deal.reservationExpiresAt | date: 'dd/MM/yyyy' }}</dd>
            </div>
          }
        </dl>

        @if (deal.reservationExpiresAt) {
          <p class="register-deal__hint">
            A reserva vale por 90 dias. Ela deixa de ter prazo assim que o primeiro documento do
            cliente for enviado.
          </p>
        }
      } @else {
        <form [formGroup]="form" (ngSubmit)="submitAction()">
          <h3 class="register-deal__card-title">CNPJ da empresa</h3>

          <!-- A dica fica DENTRO da coluna do campo, colada nele: no desenho ela pertence
               ao campo, não ao cartão — solta, ela virava mais um parágrafo e abria um
               vão entre a linha do CNPJ e o resto. Por isso a linha alinha pelo topo: a
               coluna do campo é mais alta que o botão. -->
          <div class="register-deal__cnpj-row">
            <div class="register-deal__cnpj-field">
              <app-input
                label=""
                type="cnpj"
                placeholder="00.000.000/0000-00"
                [unmask]="true"
                [required]="true"
                [formGroup]="form"
                controlName="cnpj" />

              <p class="register-deal__field-hint">
                @if (visaoInterna()) {
                  Verificamos se o CNPJ está livre ou já é um cliente da casa sem parceiro.
                } @else {
                  Verificamos a disponibilidade e criamos a reserva com carimbo de tempo.
                }
              </p>
            </div>

            <!-- Sem ícone e desligado enquanto o CNPJ não fecha 14 dígitos — é o estado
                 que o desenho mostra: cinza sólido, sem convite a clicar. A lupa fazia o
                 botão ler como um segundo campo ao lado do primeiro.
                 `[theme]="'white'"` e não `[outlined]`: o `outlined` do PrimeNG não é
                 estilizado neste design system, então o botão saía verde primário e
                 competia com a ação principal. -->
            <!-- `[noMargin]` porque o `app-button` sobe 0.6rem por padrão, para compensar
                 o rótulo do campo ao lado numa linha de formulário. Aqui o campo não tem
                 rótulo, então essa compensação virava desalinhamento: o botão ficava 10px
                 acima do topo do campo (medido). -->
            <app-button
              label="Verificar"
              [theme]="'white'"
              [noMargin]="true"
              [fitContent]="true"
              [isLoading]="lookingUp()"
              [disabled]="!canLookup || lookingUp()"
              (sendButtonClick)="lookupCnpj()" />
          </div>

          @if (lookup(); as result) {
            @if (result.isAvailable) {
              <div class="register-deal__alert register-deal__alert--ok">
                <i class="pi pi-check-circle"></i>
                <div>
                  <strong>{{ result.corporateName }}</strong>
                  @if (result.tradeName) {
                    <span class="register-deal__trade-name">({{ result.tradeName }})</span>
                  }
                  @if (result.isExistingCompany && !visaoInterna()) {
                    <!-- Card 3190: a empresa já é do parceiro (reserva, vínculo ou deal anterior). -->
                    <p>
                      Esta empresa já é sua. O novo deal fica ligado a ela, sem criar outra empresa
                      nem uma nova reserva do CNPJ. Informe o valor para registrar; o prazo é
                      opcional.
                    </p>
                  } @else if (result.isExistingCompany) {
                    <p>
                      Empresa já cadastrada no Cognito. O deal será ligado a ela, sem criar outra
                      empresa nem reservar o CNPJ. Informe o valor para registrar; o prazo é
                      opcional.
                    </p>
                  } @else {
                    <p>CNPJ disponível. Informe o valor para registrar; o prazo é opcional.</p>
                  }
                </div>
              </div>

              <!-- Valor e prazo lado a lado (card 3683): o prazo é opcional e define o flat fee da
                   operação; a linha abaixo mostra a estimativa (mesma tabela da Calculadora) só
                   quando há prazo. A opção vazia do select volta para "sem prazo". -->
              <div class="register-deal__amount-row">
                <app-input
                  class="register-deal__amount-field"
                  label="Valor pretendido"
                  type="number"
                  prefix="R$ "
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [required]="true"
                  [formGroup]="form"
                  controlName="amount" />

                <app-select
                  class="register-deal__term-field"
                  [label]="'Prazo da captação'"
                  [options]="termYearsOptions"
                  [hasFilter]="false"
                  [allowEmptyPlaceholderSelect]="true"
                  [formGroup]="form"
                  controlName="termYears"
                  [placeholder]="'Selecione (opcional)'" />
              </div>

              @if (flatFeeEstimate(); as estimate) {
                <p class="register-deal__estimate">
                  Flat fee estimado: {{ estimate.flatFeePercent | vaultFormatPercent: 2 }} ≈
                  {{ estimate.flatFeeAmount | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
                </p>
              }

              <div class="register-deal__actions">
                <!-- Só o `type="submit"` dispara o envio. Somar `(sendButtonClick)` aqui
                     chamava `submitAction()` duas vezes no mesmo clique — o `app-button`
                     renderiza um submit nativo, então o clique já sobe pelo `(ngSubmit)`.
                     No deal originado pela Legatus, que não reserva CNPJ, os dois passavam
                     e nasciam dois deals iguais. -->
                <app-button
                  [label]="result.isExistingCompany ? 'Registrar deal' : 'Registrar e reservar'"
                  icon="pi pi-check"
                  type="submit"
                  [isLoading]="saving()"
                  [disabled]="!canSubmit || saving()" />
              </div>
            } @else {
              <div class="register-deal__alert register-deal__alert--blocked">
                <i class="pi pi-exclamation-triangle"></i>
                <p>{{ result.unavailableReason }}</p>
              </div>
            }
          }
        </form>
      }
    </section>

    <!-- 2. Documentação ---------------------------------------------------------- -->
    <section class="register-deal__card">
      <h3 class="register-deal__card-title">Documentação da empresa</h3>

      <!-- A zona só liga com o CNPJ verificado e livre, ou com o deal já criado (card 3670):
           antes disso a pessoa ainda não sabe se o deal vai existir. Com ela ligada, os arquivos
           ficam em espera e sobem sozinhos assim que o deal é registrado. O upload precisa de um
           deal (`POST deals/{id}/documents`), por isso a espera.

           Tema `dropzone` do `app-document-attachment` (regra 5 do guia do frontend): ele
           é sem estado e só entrega a área de arraste + a validação de formato/tamanho. As
           duas listas abaixo continuam da tela porque têm semânticas próprias — em espera
           e enviados com o andamento da classificação. -->
      <app-document-attachment
        theme="dropzone"
        dropzoneTitle="Arraste os documentos aqui"
        dropzoneHint="O Cog identifica o que é cada arquivo — sem formulário, sem nomenclatura."
        [busy]="uploading()"
        [disabled]="!canAttachFiles"
        disabledHint="Verifique o CNPJ para enviar documentos."
        [maxFiles]="maxFiles"
        [attachedCount]="pendingFiles().length + documents().length + sendingFiles().length"
        [acceptedFormats]="formatosAceitos"
        [invalidFileMessage]="mensagemArquivoInvalido"
        (sendDocument)="onFilesChosen($event)" />

      <p class="register-deal__field-hint">
        Balanço, DRE ou balancete — qualquer um serve.
        @if (!visaoInterna()) {
          O primeiro documento enviado torna a reserva do CNPJ definitiva, sem prazo.
        }
      </p>

      <!-- Em espera: ainda não há deal para receber o arquivo. -->
      @if (pendingFiles().length > 0) {
        <div class="register-deal__pending">
          <p class="register-deal__pending-lead">
            {{ pendingFiles().length }}
            {{ pendingFiles().length === 1 ? 'arquivo em espera' : 'arquivos em espera' }} — serão
            enviados assim que você registrar o deal.
          </p>

          <ul class="register-deal__doc-list">
            @for (file of pendingFiles(); track file.name + file.size; let i = $index) {
              <li class="register-deal__doc">
                <i class="pi pi-file"></i>
                <span class="register-deal__doc-name">{{ file.name }}</span>
                <app-button
                  icon="pi pi-times"
                  [pureIcon]="true"
                  [theme]="'white'"
                  title="Remover da lista"
                  (sendButtonClick)="removePendingFile(i)" />
              </li>
            }
          </ul>
        </div>
      }

      <!-- Saindo do navegador (card 3670): sair da tela agora cancela o envio, por isso aparece
           por arquivo e não só no selo da área de arraste. -->
      @if (sendingFiles().length > 0) {
        <ul class="register-deal__doc-list">
          @for (item of sendingFiles(); track item.file) {
            <li class="register-deal__doc">
              <i class="pi pi-file"></i>
              <span class="register-deal__doc-name">{{ item.file.name }}</span>
              <span class="register-deal__doc-status" data-status="Sending">Enviando…</span>
            </li>
          }
        </ul>
      }

      @if (documents().length > 0) {
        <ul class="register-deal__doc-list">
          @for (doc of documents(); track doc.id) {
            <li class="register-deal__doc">
              <i class="pi pi-file"></i>
              <span class="register-deal__doc-name">{{ doc.fileName }}</span>

              @if (doc.classifiedAs) {
                <span class="register-deal__doc-tag">{{ doc.classifiedAs }}</span>
              }

              <span class="register-deal__doc-status" [attr.data-status]="doc.status">
                {{ statusLabel(doc.status) }}
              </span>
            </li>

            @if (doc.status === 'Failed' && doc.failureReason) {
              <li class="register-deal__doc-error">{{ doc.failureReason }}</li>
            }

            <!-- Classificou bem mas não casou com o checklist: o arquivo continua aqui, e
                 o motivo fica à vista em vez de o envio parecer ter sumido. É aviso, não
                 erro — por isso não usa o estilo de falha. -->
            @if (doc.status === 'Completed' && doc.archivingNote) {
              <li class="register-deal__doc-note">{{ doc.archivingNote }}</li>
            }
          }
        </ul>
      }

      @if (createdDeal()) {
        <!-- Secundário de propósito. Em verde primário, esta ação — que TIRA a pessoa da
             tela — ficava mais destacada que o envio dos documentos, que é o que importa
             fazer aqui. -->
        <div class="register-deal__done-actions">
          <app-button
            label="Registrar outro deal"
            icon="pi pi-plus"
            [theme]="'white'"
            [fitContent]="true"
            (sendButtonClick)="registerAnother()" />
        </div>
      }
    </section>
  </div>
</div>
